import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitofivejyotilinga() {



const cardData = {
  keyword: " Mumbai to 5 Jyotirlinga Cab ",

headingDescription: "Velocity Cab offers reliable and comfortable Mumbai to 5 Jyotirlinga cab services, designed for spiritual journeys, pilgrimage tours, and devotional travel. Our professional drivers, well‑maintained vehicles, and flexible pickup options ensure a smooth and stress‑free trip from Mumbai to the sacred Jyotirlinga temples across Maharashtra and neighboring states. We provide customizable routes, transparent pricing with no hidden charges, and a fleet of air‑conditioned sedans, spacious SUVs, and luxury cars suitable for family groups, devotees, and corporate pilgrims. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to 5 Jyotirlinga cab travel.",

topPlaces: [
  {
    title: "Trimbakeshwar Jyotirlinga (Nashik)",
    description: "Trimbakeshwar Jyotirlinga is one of the twelve sacred Jyotirlinga temples dedicated to Lord Shiva, located near Nashik. Travelers from Mumbai can take a cab to this revered site to participate in traditional darshan, abhishekam rituals, and prayers. The temple’s serene ambience, historic architecture, and proximity to the source of the Godavari River make it a major pilgrimage destination. Devotees often combine the trip with holy dips in the river and visits to nearby religious spots."
  },
  {
    title: "Grishneshwar Jyotirlinga (Ellora, Aurangabad)",
    description: "Grishneshwar Jyotirlinga, situated near the famous Ellora Caves, is an ancient temple complex dedicated to Lord Shiva. Travelers from Mumbai can book a cab to this spiritual site to experience its beautifully carved architecture, peaceful surroundings, and devotional rituals. The temple is part of the historic Ellora UNESCO World Heritage site, allowing pilgrims to blend spiritual and cultural exploration in one visit."
  },
  {
    title: "Shri Bhimashankar Jyotirlinga (Pune District)",
    description: "Shri Bhimashankar Jyotirlinga is one of the most revered Shiva shrines located deep in the Sahyadri hills near Pune. Travelers from Mumbai can enjoy a scenic cab journey to this temple set amidst dense forests, waterfalls, and trekking paths. The site offers divine darshan, spiritual ceremonies, and nature‑rich surroundings that appeal to pilgrims and nature lovers alike. It is considered especially auspicious for devotees seeking blessings and spiritual solace."
  },
  {
    title: "Shri Kedarnath Jyotirlinga (Uttarakhand)",
    description: "Shri Kedarnath Jyotirlinga is one of India’s most sacred Shiva temples located in the Himalayas (Uttarakhand). While the cab portion from Mumbai usually goes up to Rishikesh or nearby access points before pilgrims continue by foot or helicopter, travelers from Mumbai can book a long‑distance cab for a multi‑day devotional tour. This journey combines spiritual darshan with breathtaking mountain landscapes, morning prayers, and yoga/meditation experiences near the Ganges."
  },
  {
    title: "Shri Somnath Jyotirlinga (Gujarat)",
    description: "Shri Somnath Jyotirlinga is one of the most ancient and significant Shiva temples on India’s western coast in Gujarat. Travelers from Mumbai can take a cab to Somnath to enjoy darshan, participate in evening aarti by the sea, and explore the historic temple complex. The peaceful ocean views and centuries‑old temple architecture make this pilgrimage deeply meaningful for devotees and cultural travelers alike."
  }
],



services: [
{
name: "Mumbai to 5 Jyotirlinga Cab Package",
description: "Mumbai to 5 Jyotirlinga cab package offers a complete spiritual journey covering the sacred Jyotirlingas such as Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. This package is specially designed for devotees seeking a peaceful and well-planned pilgrimage experience from Mumbai. Comfortable AC vehicles, experienced drivers, and flexible travel schedules ensure a smooth yatra across multiple destinations. The journey includes scenic routes, temple visits, and proper halts for rest and meals. Travelers can choose from sedan, SUV, or tempo traveller options depending on group size. With easy booking and transparent pricing, this cab package ensures a hassle-free and divine travel experience."
},
{
name: "Panch Jyotirlinga Tour from Mumbai",
description: "Panch Jyotirlinga tour from Mumbai provides a well-organized pilgrimage covering five sacred Jyotirlinga temples with comfortable travel arrangements. This tour is ideal for families and groups seeking a spiritual journey with proper planning and safety."
},
{
name: "Mumbai to Jyotirlinga Darshan Cab",
description: "Mumbai to Jyotirlinga darshan cab service offers convenient travel for devotees visiting holy temples with experienced drivers and comfortable vehicles ensuring a peaceful journey."
},
{
name: "5 Jyotirlinga Taxi Package Mumbai",
description: "5 Jyotirlinga taxi package Mumbai provides a complete temple tour plan with fixed itinerary, reliable drivers, and comfortable vehicles for a stress-free pilgrimage experience."
},
{
name: "Mumbai Jyotirlinga Tour by Cab",
description: "Mumbai Jyotirlinga tour by cab ensures personalized travel experience with flexible routes, private vehicles, and convenient temple visits for devotees."
},
{
name: "Panch Jyotirlinga Yatra Cab Service",
description: "Panch Jyotirlinga yatra cab service offers safe and comfortable travel for long-distance temple tours with professional drivers and well-maintained vehicles."
},
{
name: "Mumbai to Bhimashankar Grishneshwar Cab",
description: "Mumbai to Bhimashankar and Grishneshwar cab service provides direct and comfortable travel for devotees visiting these important Jyotirlinga temples with ease."
},
{
name: "Mumbai Religious Tour Cab",
description: "Mumbai religious tour cab service covers multiple temples and pilgrimage destinations with well-planned routes and comfortable travel options."
},
{
name: "5 Jyotirlinga Darshan Taxi Mumbai",
description: "5 Jyotirlinga darshan taxi Mumbai ensures a complete pilgrimage journey with comfortable vehicles, experienced drivers, and flexible travel schedules."
},
{
name: "Mumbai to Jyotirlinga Outstation Cab",
description: "Mumbai to Jyotirlinga outstation cab service provides long-distance travel solutions for devotees with safe driving and comfortable vehicles."
},
{
name: "Mumbai to Jyotirlinga Cab Fare",
description: "Mumbai to Jyotirlinga cab fare offers transparent pricing based on distance, vehicle type, and duration, helping travelers plan their pilgrimage budget efficiently."
},
{
name: "Private Cab for Jyotirlinga Tour Mumbai",
description: "Private cab for Jyotirlinga tour Mumbai provides exclusive travel experience with dedicated vehicle and flexible itinerary, ideal for families and groups."
},
{
name: "Mumbai Jyotirlinga Tour Package Taxi",
description: "Mumbai Jyotirlinga tour package taxi offers a complete travel solution with fixed routes, professional drivers, and comfortable vehicles for a smooth pilgrimage."
},
{
name: "AC Cab for 5 Jyotirlinga Yatra",
description: "AC cab for 5 Jyotirlinga yatra ensures a comfortable and relaxing journey in air-conditioned vehicles, ideal for long-distance temple tours in all seasons."
}
],

tableData: [
["Mumbai to 5 Jyotirlinga Cab Package","Panch Jyotirlinga Tour from Mumbai"],
["Mumbai to Jyotirlinga Darshan Cab","5 Jyotirlinga Taxi Package Mumbai"],
["Mumbai Jyotirlinga Tour by Cab","Panch Jyotirlinga Yatra Cab Service"],
["Mumbai to Bhimashankar Grishneshwar Cab","Mumbai Religious Tour Cab"],
["5 Jyotirlinga Darshan Taxi Mumbai","Mumbai to Jyotirlinga Outstation Cab"],
["Mumbai to Jyotirlinga Cab Fare","Private Cab for Jyotirlinga Tour Mumbai"],
["Mumbai Jyotirlinga Tour Package Taxi","AC Cab for 5 Jyotirlinga Yatra"]
],



whychoose: [
  {
    WhyChooseheading: "Complete 5 Jyotirlinga Darshan Package",
    WhyChoosedescription: "Velocity Cabs offers well-planned Mumbai to 5 Jyotirlinga cab packages covering major Jyotirlinga temples like Bhimashankar, Trimbakeshwar, Grishneshwar, Parli Vaijnath, and Aundha Nagnath for a divine pilgrimage experience."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Drivers",
    WhyChoosedescription: "Our drivers are experienced in long-distance temple routes and ghat sections, ensuring safe, smooth, and comfortable journeys throughout the Jyotirlinga yatra."
  },
  {
    WhyChooseheading: "Transparent Tour Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to 5 Jyotirlinga cab packages. Customers receive complete details including travel cost, toll charges, and driver allowance."
  },
  {
    WhyChooseheading: "Multi-Day Flexible Travel Plans",
    WhyChoosedescription: "We offer flexible multi-day travel plans for 5 Jyotirlinga darshan, allowing customers to customize routes, halts, and temple visits as per their convenience."
  },
  {
    WhyChooseheading: "Comfortable AC Vehicles for Long Travel",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and designed for long-distance travel to ensure maximum comfort during your spiritual journey."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families and group pilgrimage tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, railway stations, and airports across Mumbai for a smooth start to your Jyotirlinga yatra."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many devotees for Mumbai to 5 Jyotirlinga cab bookings due to reliable service, professional drivers, and comfortable travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to 5 Jyotirlinga cab service?", answer: "Yes, Velocity Cabs provides complete cab packages for Mumbai to 5 Jyotirlinga darshan." },
  { question: "Which Jyotirlingas are covered in this package?", answer: "The package usually includes Bhimashankar, Trimbakeshwar, Grishneshwar, Parli Vaijnath, and Aundha Nagnath." },
  { question: "How many days are required for 5 Jyotirlinga darshan?", answer: "Typically, 3 to 5 days are required depending on travel plan and temple visit duration." },
  { question: "Which vehicles are available for Jyotirlinga travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the Jyotirlinga tour package?", answer: "Yes, customers can customize routes, number of days, and temple visits as per their preference." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Yes, advance booking is recommended for pilgrimage tours to ensure availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Jadhav",
    feedback:
      "A truly memorable spiritual journey covering the 5 Jyotirlingas from Mumbai. The cab was comfortable, the itinerary was well-planned, and the long trip felt smooth and peaceful.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Kulkarni",
    feedback:
      "The 5 Jyotirlinga tour from Mumbai was managed very well. The vehicle was clean, the ride was steady, and the entire pilgrimage experience felt comfortable and well-organized.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mumbaiJyotirlingaJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to 5 Jyotirlinga Cab | Velocity Cabs",
  "description": "Book a private cab for Panch Jyotirlinga Yatra from Mumbai. Visit Bhimashankar, Grishneshwar, and other Jyotirlingas with AC and comfortable cabs. Ideal for religious tours with one-way or round-trip options.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Jyotirlinga Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "Mumbai to 5 Jyotirlinga Cab Package",
        "description": "Private cab for Panch Jyotirlinga Yatra from Mumbai, including Bhimashankar and Grishneshwar.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "AC Cab for 5 Jyotirlinga Yatra",
        "description": "Comfortable AC cab for religious tour covering all five Jyotirlingas from Mumbai.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab for Panch Jyotirlinga Yatra from Mumbai. Visit Bhimashankar, Grishneshwar, and other Jyotirlingas with AC and comfortable cabs. One-way and round-trip options available."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiJyotirlingaJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitofivejyotilinga;